/// <amd-module name="Widgets/SprintBurndownConfig/MetaSprintBurndownConfig" />
import { ConfigProps } from "Dashboards/WidgetContracts/Internal/ConfigProps";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { isLegacyWidget } from "Widgets/SprintBurndownWidget/SprintBurndownSettingsManager";
import { AnalyticsSprintBurndownConfig } from "./AnalyticsSprintBurndownConfig";
import { SprintBurndownConfig } from "./SprintBurndownConfig";

interface BurndownConfigState {
    isInLegacyMode: boolean;
    // Used to ask children to immediately notify with current state to drive a re-render
    hasToggled: boolean;
}

/** This layer mediates between legacy and modern config experience which both use their own strongly typed config settings models */
export class MetaSprintBurndownConfig extends VssComponent<ConfigProps, BurndownConfigState> {
    public static componentType = "MetaSprintBurndownConfig";

    public async componentDidMount(): Promise<void> {
        const isInLegacyMode = isLegacyWidget(this.props.config);
        this.setState({ isInLegacyMode: isInLegacyMode });
    }

    public render(): JSX.Element | null {
        if (this.state) {
            if (this.state.isInLegacyMode) {
                return <SprintBurndownConfig {...this.props} onToggleConfig={this.toggleConfigMode} isReload={this.state.hasToggled} />;
            } else {
                return <AnalyticsSprintBurndownConfig {...this.props} onToggleConfig={this.toggleConfigMode} isReload={this.state.hasToggled} />;
            }
        }
        return null;
    }

    private toggleConfigMode = (useLegacyMode: boolean): void => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("Dashboards", "SprintBurndownWidgetConfigToggle", {
            widgetId: this.props.config && this.props.config.id,
            status: useLegacyMode ? "Downgrade" : "Upgrade"
        });
        this.setState({
            isInLegacyMode: useLegacyMode,
            hasToggled: true
        });
    };
}

VssComponent.register(MetaSprintBurndownConfig.componentType, MetaSprintBurndownConfig);
